module.exports = __webpack_public_path__ + "img/headshot4.7af5fa3f.jpg";